import React from "react";
import { CardSize } from "../types/constants";
import { isCardLarge } from "../utils/helpers";
import { Link } from "react-router-dom";

interface EducationCardProps {
    title: string;
    text: string;
    icon: string;
    stats?: string;
    size?: CardSize;
}

export default function EducationCard({ title, text, icon, stats, size = CardSize.SMALL }: EducationCardProps) {
    const isLarge = isCardLarge(size);
    const baseCardStyles =
        "bg-white border border-border-400 rounded-[6px] shadow-[0px_4px_4px_0px_#36335214] p-[20px] flex gap-[16px]";
    const baseContentStyles = "flex flex-col gap-[8px]";
    const baseIconWrapper = "flex items-center justify-center rounded-full";
    const baseIcon = "w-[50px] h-[50px]";
    const sizeCardStyles = isLarge
        ? "w-full md:w-full lap:w-[480px] xl:w-[582px] lg:w-[630px] h-[142px] md:h-[165px]"
        : "w-full md:w-[calc(70%-7.5px)] lap:w-[229px] xl:w-[281px] lg:w-[305px] h-[142px] md:h-[165px]";
    const sizeContentWidth = isLarge ? "w-[514px]" : "w-[189px]";
    const sizeIconWrapper = isLarge ? "xl:w-[60px] xl:h-[60px]" : "";
//    const statsStyles = isLarge ? "text-center self-center" : "";

    return (
        <Link to="/courses">
            <button className={`${baseCardStyles} ${sizeCardStyles}`}>
                <div className={`${baseIconWrapper} w-[50px] h-[50px] ${sizeIconWrapper}`}>
                    <img src={icon} alt={title} className={baseIcon} />
                </div>

                <div className={`${baseContentStyles} ${sizeContentWidth}`}>
                    <div className={baseContentStyles}>
                        <h4 className="font-geologica font-medium text-base xl:text-lg leading-[130%] text-text-700">
                            {title}
                        </h4>
                        <p className="font-geologica font-regular text-sm xl:text-base leading-[130%] text-text-300">
                            {text}
                        </p>
                    </div>
                {/*    {stats && (
                        <p
                            className={`font-geologica font-semibold text-base leading-[130%] text-primary-400 ${statsStyles}`}
                        >
                            {stats}
                        </p>
                    )}
                    */}
                </div>
            </button>
        </Link>
    );
}
